import { Button, Typography } from "@mui/material";
import { AppRoutes } from "enums/routes.enum";
import { useTranslation } from "hooks";
import { useNavigate } from "react-router-dom";

export const LogInButton = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleClick = () => navigate(AppRoutes.LOG_IN);

    return (
        <Button
            variant="xs"
            sx={(theme) => ({
                width: "100%",
                textTransform: "capitalize",
                background: "none",
                border: `1px solid ${theme.palette.background.whiteOpacity4}`,
                minHeight: "40px",
            })}
            onClick={handleClick}
        >
            <Typography variant="body2Regular">{t("Log in").toLowerCase()}</Typography>
        </Button>
    );
};
